/**
 * Shared config for the Insights library.
 *
 * How to add a new article:
 *   1. Create a new file in `./articles/<slug>.js` that default-exports an
 *      article object matching the shape used by the existing articles.
 *   2. Import it in `./index.js` and push it onto `ARTICLES`.
 *   3. (Optional) add the slug to `/public/sitemap.xml`.
 *
 * Articles are authored as Markdown strings so they render through
 * `react-markdown` — no CMS required. Use H2/H3 for section headings; the
 * article page builds its Table of Contents from the H2 list automatically.
 */

export const DEFAULT_AUTHOR = {
  name: "The Modern Exit",
  role: "Revenue Systems Studio",
};

/** All allowed category slugs. Keep in lockstep with what the UI renders. */
export const CATEGORIES = [
  { slug: "website-strategy", label: "Website Strategy" },
  { slug: "revenue-systems", label: "Revenue Systems" },
  { slug: "lead-capture", label: "Lead Capture" },
  { slug: "booking-flow", label: "Booking Flow" },
  { slug: "crm-followup", label: "CRM & Follow-Up" },
  { slug: "automation", label: "Automation" },
  { slug: "local-service-growth", label: "Local Service Business Growth" },
];

export const getCategory = (slug) =>
  CATEGORIES.find((c) => c.slug === slug) || null;

/** Rough reading-time estimate (200 wpm) — used when an article doesn't
 *  explicitly set one. */
export const estimateReadingTime = (markdown = "") => {
  const words = markdown.trim().split(/\s+/).length;
  return Math.max(1, Math.round(words / 220));
};
